export var officialDomains = [
  { label: '官方主域名', url: 'xpj88.online' },
  { label: '备用域名一', url: 'xpj88.xin' },
  { label: '备用域名二', url: 'xpj88.live' },
  { label: '备用域名三', url: '9775673.com' },
];

export function officialText(siteName, domains) {
  var lines = domains.map(function (d) { return d.label + '：' + d.url; });
  return siteName + ' · 官方永久网址\n\n' + lines.join('\n') + '\n\n请妥善保存，以上任一网址均可访问官网。';
}

export function copyPlain(text) {
  var input = document.createElement('textarea');
  input.style.position = 'fixed';
  input.style.top = '0';
  input.style.opacity = '0';
  input.value = text;
  document.body.appendChild(input);
  input.select();
  input.setSelectionRange(0, text.length);
  var ok = false;
  try {
    ok = document.execCommand('copy');
  } catch (e) {
    ok = false;
  }
  document.body.removeChild(input);
  return ok;
}

export function downloadPlain(filename, text) {
  try {
    var blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
    return true;
  } catch (e) {
    return false;
  }
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

export function drawOfficialPoster(siteName, domains) {
  var W = 750;
  var rowH = 118;
  var cardH = 36 + domains.length * rowH;
  var H = 250 + cardH + 110;
  var c = document.createElement('canvas');
  c.width = W;
  c.height = H;
  var ctx = c.getContext('2d');
  var bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, '#4a1830');
  bg.addColorStop(1, '#1c0c14');
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = '#e8c98a';
  ctx.fillRect(0, 0, W, 8);
  ctx.fillStyle = '#ffffff';
  ctx.textAlign = 'center';
  ctx.font = 'bold 46px sans-serif';
  ctx.fillText(siteName || '澳门·新葡京', W / 2, 92);
  ctx.fillStyle = '#e8c98a';
  ctx.font = '26px sans-serif';
  ctx.fillText('官方永久网址', W / 2, 140);
  var cardX = 48;
  var cardY = 180;
  var cardW = W - 96;
  roundRect(ctx, cardX, cardY, cardW, cardH, 28);
  ctx.fillStyle = '#ffffff';
  ctx.fill();
  domains.forEach(function (d, i) {
    var y = cardY + 48 + i * rowH;
    ctx.fillStyle = '#8a756c';
    ctx.font = '24px sans-serif';
    ctx.fillText(d.label, W / 2, y);
    ctx.fillStyle = '#6e2438';
    ctx.font = 'bold 40px sans-serif';
    ctx.fillText(d.url, W / 2, y + 48);
  });
  ctx.fillStyle = '#f3e6d4';
  ctx.font = '24px sans-serif';
  ctx.fillText('请保存本图，任一网址均可回家', W / 2, H - 48);
  return c.toDataURL('image/png');
}



// WEBPACK FOOTER //
// ./src/components/mode/officialDomains.js